<template>
  <div>
    <div class="clearfix">
      <el-input class="search-input" type="text" v-model="mediaNameId" placeholder="素材ID或素材名称搜索" clearable @keyup.enter.native="search" @clear="search">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <Table
      ref="table"
      :props="table.props"
      :header="table.header.filter(item => item.isShow === true)"
      :data="table.data"
    />
    <pagination
      :currentpage="pager.currentPage"
      :pagesize="pager.pageSize"
      :totalcount="pager.totalCount"
      @handle-size-change="handleSizeChange"
      @handle-current-change="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { Table } from '@ccprivate/admin-toolkit'

export default {
  components: {
    Table
  },
  props: {
    mediaList: {
      type: Array,
      default: () => []
    },
    brandIcon: {
      type: Number,
      default: 0
    },
    bgImage: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mediaNameId: '',
      queryText: '',
      table: {
        props: {
          border: 'border',
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '素材',
            align: 'left',
            prop: 'media',
            'min-width': 120,
            isShow: true,
            render: (h, { row }) => {
              return <el-image style="width: 100px; height: 59px;" fit="contain" src={row.mediaIcon}></el-image>
            }
          },
          {
            label: '封面图',
            align: 'left',
            prop: 'minIcon',
            'min-width': 120,
            isShow: false,
            render: (h, { row }) => {
              return <el-image style="width: 100px;background-color:#3e649a;" fit="contain" src={row.minIcon}></el-image>
            }
          },
          {
            label: '背景图',
            align: 'left',
            prop: 'bgIcon',
            'min-width': 120,
            isShow: false,
            render: (h, { row }) => {
              return <el-image style="width: 100px;background-color:#3e649a;" fit="contain" src={row.bgIcon}></el-image>
            }
          },
          {
            label: '弹窗引导图',
            align: 'left',
            prop: 'guideIcon',
            'min-width': 110,
            isShow: false,
            render: (h, { row }) => {
              return <el-image style="width: 100px;" fit="contain" src={row.guideIcon}></el-image>
            }
          },
          {
            label: '素材ID',
            align: 'right',
            prop: 'mediaId',
            'min-width': 80,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '素材名称',
            align: 'left',
            prop: 'mediaName',
            isShow: true,
            'min-width': this.disabled === true ? 160 : 220,
            'show-overflow-tooltip': true
          },
          {
            label: '类型',
            align: 'left',
            prop: 'mediaClassId',
            'min-width': 80,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.mediaClassId === 2 ? '视频' : '图片'
            }
          },
          {
            label: '时长(秒)',
            align: 'left',
            prop: 'duration',
            'min-width': 80,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '校验码',
            align: 'left',
            prop: 'mateType',
            'min-width': 360,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              if (this.disabled) {
                return row.mateCheckCode
              }
              const repeatMediaIds = this.getRepeatMediaIds(row)
              return (
                <div>
                  <el-select size="small" style="width: 40%;margin-right: 10px" v-model={row.mateType} onChange={val => { this.changeMateType(val, row) }}>
                    <el-option value="自定义" label="自定义"></el-option>
                    <el-option value="coocaa_id" label="coocaa_id"></el-option>
                    <el-option value="md5" label="md5"></el-option>
                  </el-select>
                  {
                    row.mateType === '自定义'
                      ? <el-input size="small" style="width: 55%" v-model={row.mateCheckCode} placeholder="请输入物料校验码" clearable v-noEmoji></el-input>
                      : (row.mateType === 'coocaa_id'
                        ? <span style="font-size:12px">coocaa_id: coocaa_{row.mediaId}</span>
                        : <span style="font-size:12px">md5: {row.mateHash}</span>
                      )
                  }
                  {repeatMediaIds.length > 0 && <div class="cell-inline-tips">与素材{repeatMediaIds.join('、')}校验码重复</div> }
                </div>
              )
            }
          },
          {
            label: '操作',
            align: 'left',
            prop: 'checkStatus',
            'min-width': 80,
            isShow: this.disabled === false,
            render: (h, { row }) => {
              return <el-button type="text" onClick={() => this.removeRow(row)}>移除</el-button>
            }
          }
        ],
        data: []
      },
      pager: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0
      }
    }
  },
  watch: {
    mediaList: {
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          const newMediaIds = newVal.map(item => item.mediaId)
          const isAllSame = oldVal.every(item => newMediaIds.includes(item.mediaId))
          if (isAllSame && newVal.length === oldVal.length) {
            return
          }
          this.search()
        }
      }
    },
    brandIcon: {
      handler(val) {
        this.table.header[1].isShow = val === 1
      }
    },
    bgImage: {
      handler(val) {
        this.table.header[2].isShow = val === 1
      }
    }
  },
  methods: {
    changeMateType(val, row) {
      if (val === '自定义') {
        row.mateCheckCode = ''
      }
    },
    getRepeatMediaIds(row) {
      const curCheckCode = this.getCheckCode(row)
      return this.table.data
        .filter(item => {
          const itemCheckCode = this.getCheckCode(item)
          return row.mediaId !== item.mediaId && curCheckCode && itemCheckCode && curCheckCode === itemCheckCode
        })
        .map(item => item.mediaId)
    },
    getCheckCode(media) {
      return media.mateType === 'coocaa_id'
        ? `coocaa_${media.mediaId}`
        : (media.mateType === '自定义' ? media.mateCheckCode : media.mateHash)
    },
    search() {
      this.queryText = this.mediaNameId
      this.pager.currentPage = 1
      this.fetchData()
    },
    fetchData() {
      const pageStart = (this.pager.currentPage - 1) * this.pager.pageSize
      const pageEnd = pageStart + this.pager.pageSize
      // 是否查询名称
      const isQueryName = isNaN(parseInt(this.queryText, 10))
      const resultData = this.mediaList.filter((item, index) => {
        return isQueryName ? (item.mediaName.indexOf(this.queryText) > -1) : (item.mediaId === parseInt(this.queryText, 10))
      })
      this.table.data = resultData.filter((item, index) => {
        return index >= pageStart && index < pageEnd
      })
      this.pager.totalCount = resultData.length
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val
      this.fetchData()
    },
    removeRow(row) {
      this.$confirm('确定从已选素材中移除该行吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        showClose: false
      })
        .then(() => {
          const needRemovedIndex = this.mediaList.findIndex(item => item.mediaId === row.mediaId)
          this.mediaList.splice(needRemovedIndex, 1)
          this.search()
          this.$emit('change', this.mediaList)
        })
        .catch(() => {})
    }
  },
  created() {
    this.search()
  }
}
</script>

<style lang="stylus" scoped>
.search-input
  float right
  margin-bottom 20px
  width 300px
</style>

<style lang="stylus">
.cell-inline-tips
  font-size 12px
  color #f00
</style>
